export default "__VITE_ASSET__fd49e7e7__"